<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box-mini mb-10">
      <div class="p-15">
        <div class="row">
          <div class="col-sm-6">
            <a v-if="getRoleId != '33'" @click="openPage('/classesTime/add')" class="btn-primary"><i class="fas fa-plus-square mr-5"></i>Add</a>
          </div>
          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-4 col-form-label text-right">
                Studio
              </div>
              <div class="col-sm-8">
                <b-form-select @change="changeStudioSelect" v-model="changeStudio">
                  <option value="">All Studio</option>
                  <option v-for="item in optStudio" :key="item.id" :value="item.id">{{item.name}}</option>
                </b-form-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box-mini mb-15">
      <div class="p-15">
        <div class="text-uppercase font-600 mb-10">
          <template v-if="changeStudio === ''">
            All Studio
          </template>
          <template v-else>
          <span v-for="nameStudio in optStudio" :key="nameStudio.id">
            <span v-if="changeStudio === nameStudio.id">
              {{nameStudio.name}}
            </span>
          </span>

          </template>
        </div>
        <hr class="mb-0">
        <!-- <div v-for="itemStudio in listStudio" :key="itemStudio.id">
          <template v-if="items.studio_id === itemStudio.id">
            <div class="font-600">{{itemStudio.name}}</div>
          </template>
        </div>
        <hr class="mb-0"> -->
        <!-- {{changeStudio}} -->
        <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
          <template v-slot:cell(status)="data">
<!--          <template slot="status" slot-scope="data">-->
            <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
          </template>
          <template v-slot:cell(studio_id)="data">
<!--          <template slot="studio_id" slot-scope="data">-->
            {{data.item.studio.name}}
          </template>
          <template v-slot:cell(actions)="data">
<!--          <template slot="actions" slot-scope="data">-->
            <b-button v-if="getRoleId != '33'" size="sm" @click="editItem('/classesTime/edit?id=' + data.item.id)" class="btn-table primary mr-1">
              <i class="far fa-edit"></i>
            </b-button>
            <b-button v-if="getRoleId != '33'" size="sm" v-on:click="deleteItem(data.item.id)" class="btn-table danger">
              <i class="fas fa-times"></i>
            </b-button>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
            :total-pages="totalPage"
            @page-changed="pageOneChanged"
            prev-text="Prev" next-text="Next"/>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from '@coreui/vue'
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'

export default {
  name: 'classesTime',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: 'time_start',
          label: 'Time Start',
          sortable: true
        },
        {
          key: 'time_end',
          label: 'Time End',
          sortable: true
        },
        {
          key: 'studio_id',
          label: 'Studio',
          sortable: true
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Actions',
          sortable: false
        }
      ],
      changeStudio: '',
      items: [],
      optStudio: [],
      sortType: 'asc',
      sortBy: 'time_start',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      getRoleId: Auth.Session.get().paradigm_role
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  },
  methods: {
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchDataTime()
    },
    sortingChanged (event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchDataTime()
    },
    changeStudioSelect (event) {
      axios.get('fitness/v1/classes_time/' + event + '?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount (items) {
      return items.length
    },
    openPage (event) {
      this.$router.push(event)
    },
    editItem (event) {
      this.$router.push(event)
    },
    showModal (id) {
      this.$refs[id].show()
    },
    deleteItem(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.delete('fitness/v1/classes_time/'.concat(event)).then(response => {
            // this.$router.go()
            this.fetchDataTime()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    fetchDataTime () {
      axios.get('fitness/v1/classes_time/' + this.changeStudio + '?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType).then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
      }).catch(error => {
        console.log('error', error)
      })
    },
    fetchData() {
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('fitness/v1/studio?sorting=id&sorting_type=asc').then(response => {
        this.optStudio = response.data.data.rows
      }).catch(error => {
        console.log('error', error)
      })
    }
  },
  created () {
    this.fetchData()
    this.fetchDataTime()
  }
}
</script>

<style>
</style>
